module.exports = __webpack_public_path__ + "img/Frage3_2048x1536.a05bb3a5.jpg";